<span class="handling_days">
  <span *ngFor="let items of taskService.handlingDaysRange(data?.handling_days, data?.handled_days); let i = index;"
        class="days{{i}}"></span>
</span>
<span class="handling_text" [class.orange]="data?.handled_days > 0 && data?.handled_days <= 2" [class.red]="data?.handled_days <= 0">
  {{ data?.handled_days }} dag<span *ngIf="data?.handled_days > 1">en</span>
</span>
